import React, { forwardRef } from 'react';

const GradientPreview = forwardRef(({ background }, ref) => (
  <div
    ref={ref}
    className="ws-ui-gradient-preview"
    style={{
      '--gradient-background': background,
    }}
  />
));

GradientPreview.displayName = 'GradientPreview';

export default GradientPreview;
